import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { forwardRef, useContext, useImperativeHandle } from 'react';
import clsx from 'clsx';
import useMergedState from '../hooks/use-merged-state';
import CheckBoxContext from './CheckboxContext';
import useRefs from '../hooks/use-refs';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';
var CheckBoxGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('checkbox-group', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var _useRefs = useRefs(),
      _useRefs2 = _slicedToArray(_useRefs, 2),
      childrenRefs = _useRefs2[0],
      setChildrenRefs = _useRefs2[1];

  var _useMergedState = useMergedState({
    value: props.value,
    defaultValue: props.defaultValue
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      checked = _useMergedState2[0],
      setChecked = _useMergedState2[1];

  var toggleAll = function toggleAll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (typeof options === 'boolean') {
      options = {
        checked: options
      };
    }

    var _options = options,
        isChecked = _options.checked,
        skipDisabled = _options.skipDisabled;
    var checkedChildren = childrenRefs.filter(function (item) {
      if (!item.props.bindGroup) {
        return false;
      }

      if (item.props.disabled && skipDisabled) {
        return item.checked;
      }

      return isChecked !== null && isChecked !== void 0 ? isChecked : !item.checked;
    });
    var names = checkedChildren.map(function (item) {
      return item.props.name;
    });
    setChecked(names);
    props.onChange(names);
  };

  var toggle = function toggle(name) {
    var _props$onChange;

    setChecked(name);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, name);
  };

  useImperativeHandle(ref, function () {
    return {
      toggleAll: toggleAll
    };
  });
  return /*#__PURE__*/React.createElement(CheckBoxContext.Provider, {
    value: {
      parent: {
        props: props
      },
      toggle: toggle,
      checked: checked
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(bem([props.direction]))
  }, React.Children.toArray(props.children).filter(Boolean).map(function (child, index) {
    var _child$type;

    if (((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) !== 'Checkbox') return child;
    return /*#__PURE__*/React.cloneElement(child, {
      ref: setChildrenRefs(index)
    });
  })));
});
CheckBoxGroup.defaultProps = {
  defaultValue: []
};
export default CheckBoxGroup;